<!-- Desktop sidebar -->
<div class="sidebar">
  <ng-container *ngTemplateOutlet="sidebar"></ng-container>
</div>

<!-- Mobile sidebar -->
<ng-template #mobileSidebar>
  <!-- React to keydown event to close sidebar with escape key -->
  <div
    class="mobile-sidebar"
    [@openCloseMobileSidebar]="mobileSidebarOpened ? 'open' : 'closed'"
    (@openCloseMobileSidebar.done)="!mobileSidebarOpened ? overlayRef.detach() : null"
    (keydown.escape)="hideMobileSidebar(false)"
  >
    <!-- This div is only required because of the TrapFocus (on the parent div it does not work...) -->
    <div class="mobile-sidebar-trap-focus" cdkTrapFocus>
      <ng-container *ngTemplateOutlet="sidebar"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #sidebar>
  <nav>
    <ul class="sidebar-menu" (click)="onNavigationClick($event)">

      <!-- Overview mode: minimal menu -->
      <ng-container *ngIf="!isNoDevicesMode && isOverviewRoute">
        <li><button type="button" class="scg-unstyled-button text-left" (click)="onWebPortalClick()"><app-svg-icon [name]="'home'"></app-svg-icon><span>{{'MENU_SMALL.WEB_PORTAL_CLASSIC' | translate}}</span></button></li>
        <hr>
      </ng-container>

      <!-- Device mode: full menu -->
      <ng-container *ngIf="!isNoDevicesMode && !isOverviewRoute">
        <li><a routerLink="/dashboard" routerLinkActive="active"><app-svg-icon [name]="'home'"></app-svg-icon><span>{{'DASH.TITLE' | translate}}</span></a></li>
        <li><a routerLink="/devicelimit" routerLinkActive="active"><app-svg-icon [name]="'clock-regular'"></app-svg-icon><span>{{'DEVICELIMIT.TITLE' | translate}}</span></a></li>
        <li *ngIf="device.isFeatureSupported(Feature.webfilter)"><a routerLink="/webfilter" routerLinkActive="active"><app-svg-icon [name]="'globe'"></app-svg-icon><span>{{'WEBFILTER.TITLE' | translate}}</span></a></li>
        <li *ngIf="device.isFeatureSupported(Feature.isCB)"><a routerLink="/apps" routerLinkActive="active"><app-svg-icon [name]="'mobile-alt'"></app-svg-icon><span>{{'APPFILTER.TITLE' | translate}}</span></a></li>
        <li *ngIf="device.isFeatureSupported(Feature.isCC)"><a routerLink="/apps" routerLinkActive="active"><app-svg-icon [name]="'desktop'"></app-svg-icon><span>{{'APPFILTER.TITLE_CC' | translate}}</span></a></li>
        <li *ngIf="device.isFeatureSupported(Feature.GPS)"><a routerLink="/gps" routerLinkActive="active"><app-svg-icon [name]="'map-marker-alt'"></app-svg-icon><span>{{'GPS.TITLE' | translate}}</span></a></li>
        <li *ngIf="device.isFeatureSupported(Feature.Screenshots) || device.isFeatureSupported(Feature.ScreenshotsV2)"><a routerLink="/screenshots" routerLinkActive="active"><app-svg-icon [name]="'camera'"></app-svg-icon><span>{{'SCREENSHOTS.TITLE' | translate}}</span></a></li>
        <li><a routerLink="/security" routerLinkActive="active"><app-svg-icon [name]="'shield-alt'"></app-svg-icon><span>{{'WIN_SECURITY.TITLE' | translate}}</span></a></li>
        <li><a routerLink="/reports" routerLinkActive="active"><app-svg-icon [name]="'chart-bar'"></app-svg-icon><span>{{'REPORTS.TITLE' | translate}}</span></a></li>
        <li><a routerLink="/emailreport" routerLinkActive="active"><app-svg-icon [name]="'envelope'"></app-svg-icon><span>{{'EMAILREPORT.TITLE' | translate}}</span></a></li>
        <li><a routerLink="/settings" routerLinkActive="active"><app-svg-icon [name]="'cog'"></app-svg-icon><span>{{'SETTINGS.TITLE' | translate}}</span></a></li>
        <li><a routerLink="/tans" routerLinkActive="active"><app-svg-icon [name]="'star'"></app-svg-icon><span>{{'TANS.TITLE_LONG' | translate}}</span></a></li>
        <li><a routerLink="/sync" routerLinkActive="active"><app-svg-icon [name]="'exchange-alt'"></app-svg-icon><span>{{'SYNC.TITLE' | translate}}</span></a></li>
        <hr>
      </ng-container>

      <li><button type="button" class="scg-unstyled-button text-left" (click)="onLogoutClick()"><app-svg-icon [name]="'power-off'"></app-svg-icon><span>{{'MENU_SMALL.LOGOUT' | translate}}</span></button></li>
    </ul>
  </nav>
</ng-template>
